import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=45c10e27&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&id=45c10e27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c10e27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c10e27')) {
      api.createRecord('45c10e27', component.options)
    } else {
      api.reload('45c10e27', component.options)
    }
    module.hot.accept("./Step3.vue?vue&type=template&id=45c10e27&scoped=true&", function () {
      api.rerender('45c10e27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/form/stepForm/Step3.vue"
export default component.exports